import { Teacher } from "../types/TeacherModel"; // Import Teacher type from your types directory
import api from "./api"; // Import your configured Axios instance

// Fetch all teachers
export const getTeachers = async () => {
  try {
    const response = await api.get("/teachers");
    return response.data;
  } catch (error) {
    console.error("Failed to fetch teachers", error);
    throw error;
  }
};

// Fetch a single teacher by ID
export const getTeacher = async (id: string) => {
  try {
    const response = await api.get(`/teachers/${id}`);
    return response.data;
  } catch (error) {
    console.error("Failed to fetch teacher", error);
    throw error;
  }
};

// Create a new teacher
export const createTeacher = async (teacherData: Teacher) => {
  try {
    const response = await api.post("/teachers", teacherData, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error saving teacher:", error);
    throw error;
  }
};

// Update an existing teacher by ID
export const updateTeacher = async (
  teacherId: string,
  updatedData: Teacher
) => {
  try {
    const response = await api.put(`/teachers/${teacherId}`, updatedData, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error updating teacher:", error);
    throw error;
  }
};

// Delete a teacher by ID
export const deleteTeacher = async (teacherId: string, email: string) => {
  try {
    const response = await api.delete(`/teachers/${teacherId}?email=${email}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting teacher:", error);
    throw error;
  }
};
